import { Application, Controller } from "stimulus"
import { importAllWithKeys, getAllControllersFromDirectories } from "../shared/stimulusHelpers"

export const initComponentPublicInterface = () => {
  return (() => {
    const baseClass = class extends Controller {}

    return {
      baseClass: baseClass
    }
  })()
}

export const initControlledComponents = () => {
  const application = initStimulusApplication()

  return (() => {
    const findControllerBy = ({ name, element }) => {
      return application.getControllerForElementAndIdentifier(element, name)
    }

    return {
      findControllerBy: findControllerBy
    }
  })()
}

function initStimulusApplication() {
  const application = Application.start()
  application.load(getAllControllersFromDirectories(getImportContexts()))
  return application
}

function getImportContexts() {
  const appContexts = importAllWithKeys(require.context('../stimulusControllers/', true, /controller\.js$/))
  const componentContexts = importAllWithKeys(require.context('../../components/', true, /controller\.js$/))
  return appContexts.concat(componentContexts)
}



// WEBPACK FOOTER //
// ./app/javascript/shared/controlledComponents.js